import { useState } from "react";
import ReactPlayer from "react-player/file";
import { BasePlayer } from "./BasePlayer";

export const NASPlayer = ({playerRef, playing, onProgress, onDuration, onSourceChange, playbackRate, volume, game, children, ...sessionProps}) => {
  const [url, setURL] = useState("");
  const [gameid, setGameid] = useState("")
  const [inputError, setInputError] = useState(false)

  const handleVideoLinking = () => {
    const id = gameid.trim()
    const year = String(game?.year ?? "").trim()
    const league = String(game?.league_id ?? "").trim()
    if (!id || !year || !league) {
      setInputError(true)
      return
    }
    setInputError(false)
    setGameid(id)
    const encodedId = encodeURIComponent(id)
    setURL(`https://xstats-insight.synology.me/gamevideo/broadcast/${encodeURIComponent(year)}/${encodeURIComponent(league)}/G${encodedId}/G${encodedId}.m3u8`)
  }

  return (
    <BasePlayer
      {...sessionProps}
      Player={ReactPlayer}
      url={url}
      playerRef={playerRef}
      playing={playing}
      onProgress={onProgress}
      onDuration={onDuration}
      onSourceChange={onSourceChange}
      playbackRate={playbackRate}
      volume={volume}
      config={{ file: { forceHLS: true } }}
      videoInput={
        <>
          <label className="source-field">NAS 影片編號<input aria-label="NAS 影片編號" value={gameid} onChange={(e) => {setGameid(e.target.value)}} placeholder="NAS 影片編號" /></label>
          <button onClick={handleVideoLinking}>連結影片</button>
          <span className="game-bar-hint">使用上方年份與聯盟；影片編號可與現況賽事編號不同</span>
          {inputError && <span className="video-url-error" role="alert" style={{ color: "#f87171" }}>請選擇上方年份與聯盟，並輸入 NAS 影片編號</span>}
        </>
      }
    >
      {children}
    </BasePlayer>
  );
};
